import { render, staticRenderFns } from "./homepage-aggregators.vue?vue&type=template&id=3c5c8bcf&"
import script from "./homepage-aggregators.vue?vue&type=script&lang=js&"
export * from "./homepage-aggregators.vue?vue&type=script&lang=js&"
import style0 from "./homepage-aggregators.vue?vue&type=style&index=0&id=3c5c8bcf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports